import Vue from 'vue'
import fastclick from 'fastclick'
import App from './App.vue'
import router from './router'
import api from './api'
import '@/assets/fonts/font.css'
Vue.prototype.$api = api
import "@/utils/flexible";
import '@/assets/style/reset.css'
import '@/assets/style/boder.css'

Vue.config.productionTip = false
fastclick.attach(document.body)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
